import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '@awesome.me/webawesome/dist/components/icon/icon.js';

@customElement('app-nav-bar')
export class AppNavBar extends LitElement {
  @state() private _currentPath = window.location.pathname;

  static styles = css`
    :host {
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: #181818;
      border-top: 1px solid #2A2A2A;
      height: 60px;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100vw;
      z-index: 100;
      box-sizing: border-box;
    }

    a {
      color: #A0A0A0;
      text-decoration: none;
      font-family: var(--font-body);
      font-size: 0.85rem;
      font-weight: 500;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      transition: color 0.2s ease;
      width: 50%;
    }

    wa-icon {
      font-size: 1.2rem;
      line-height: 1;
    }

    a.active {
      color: var(--accent-orange, #FF6600);
    }

    a.active wa-icon {
      color: var(--accent-orange, #FF6600);
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('popstate', this._updatePath);
    window.addEventListener('route-changed', this._updatePath);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('popstate', this._updatePath);
    window.removeEventListener('route-changed', this._updatePath);
  }

  private _updatePath = () => {
    this._currentPath = window.location.pathname;
  };

  private _isActive(path: string): boolean {
    if (path === '/') return this._currentPath === '/';
    return this._currentPath.startsWith(path);
  }

  render() {
    return html`
      <a href="/" class="${this._isActive('/') ? 'active' : ''}">
        <wa-icon name="house" label="Inicio"></wa-icon>
        Inicio
      </a>

      <a href="/store" class="${this._isActive('/store') ? 'active' : ''}">
        <wa-icon name="map-location-dot" label="Tienda"></wa-icon>
        Tienda GPX
      </a>
    `;
  }
}